/* ============================================================
   EGOSS ATELIER — PDP client-side enhancements
   1. Gallery prev/next arrows overlaid on the main image
   2. Width customisation text block → collapsible <details>

   Scoped to .shopify-section--main-product only.
   Idempotent: guards prevent double-init across partial rerenders.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- 1. Gallery arrows ---------- */

  var initGalleryArrows = function () {
    var carousel = document.querySelector(
      '.shopify-section--main-product .product-gallery__carousel'
    );
    if (!carousel || !carousel.id) return;
    if (carousel.__atelierArrowsInit) return;
    carousel.__atelierArrowsInit = true;

    var gallery = carousel.closest('.product-gallery');
    if (!gallery) return;

    // Ensure the gallery is a positioning context for the absolute arrows.
    // CSS also sets position: relative, belt-and-braces.
    if (getComputedStyle(gallery).position === 'static') {
      gallery.style.position = 'relative';
    }

    var svgFor = function (dir) {
      var d = dir === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6';
      return (
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ' +
        'aria-hidden="true"><path d="' + d + '"/></svg>'
      );
    };

    var makeArrow = function (dir) {
      var wrapper = document.createElement(
        dir === 'prev' ? 'carousel-prev-button' : 'carousel-next-button'
      );
      wrapper.setAttribute('aria-controls', carousel.id);
      wrapper.classList.add('pdp-gallery-arrow', 'pdp-gallery-arrow--' + dir);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute(
        'aria-label',
        dir === 'prev' ? 'Previous image' : 'Next image'
      );
      btn.innerHTML = svgFor(dir);

      wrapper.appendChild(btn);
      return wrapper;
    };

    gallery.appendChild(makeArrow('prev'));
    gallery.appendChild(makeArrow('next'));
  };

  /* ---------- 2. Width customisation collapsible ---------- */

  var SUMMARY_LABEL = 'Extra-wide feet? Width customisation available';

  var initWidthCollapsible = function () {
    var prose = document.querySelector(
      '.shopify-section--main-product [data-block-id="text_YFipm3"] .prose'
    );
    if (!prose) return;
    if (prose.__atelierCollapsibleInit) return;
    prose.__atelierCollapsibleInit = true;

    var details = document.createElement('details');
    details.className = 'pdp-width-details';

    var summary = document.createElement('summary');
    summary.className = 'pdp-width-details__summary';
    summary.textContent = SUMMARY_LABEL;

    var content = document.createElement('div');
    content.className = 'pdp-width-details__content';

    // Move existing merchant-edited content (richtext paragraph) into details
    while (prose.firstChild) content.appendChild(prose.firstChild);

    details.appendChild(summary);
    details.appendChild(content);
    prose.appendChild(details);
  };

  /* ---------- boot ---------- */

  /* ---------- 3. Variant-conditional text block (Phase 3e) ---------- */

  /* Shows / hides [data-egoss-variant-text] blocks based on the currently
     selected value of a named option (e.g. "Edition" == "Limited").
     Reads the selected value from the variant-picker DOM — works for both
     block and dropdown selector styles. Server renders initial state via
     the `hidden` attribute; this JS toggles it on variant change. */

  var normaliseVariantText = function (s) {
    return String(s == null ? '' : s).trim().toLowerCase();
  };

  var getSelectedValueForOption = function (picker, targetName) {
    if (!picker) return '';
    var target = normaliseVariantText(targetName);

    var fieldsets = picker.querySelectorAll('fieldset.variant-picker__option');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var legend = fs.querySelector('legend');
      if (!legend) continue;
      var legendText = normaliseVariantText(legend.textContent.replace(/:$/, ''));
      if (legendText !== target) continue;

      // Block / swatch / variant_image: checked radio → look up its label text
      var checkedInput = fs.querySelector('input[data-option-position]:checked');
      if (checkedInput) {
        var label = fs.querySelector('label[for="' + checkedInput.id + '"]');
        if (label) {
          var srOnly = label.querySelector('.sr-only');
          var visibleSpan = null;
          var spans = label.querySelectorAll('span');
          for (var j = 0; j < spans.length; j++) {
            if (spans[j] !== srOnly && !spans[j].classList.contains('block-swatch__color')) {
              visibleSpan = spans[j];
              break;
            }
          }
          if (visibleSpan) return visibleSpan.textContent.trim();
          if (srOnly) return srOnly.textContent.trim();
          return label.textContent.trim();
        }
      }

      // Dropdown: the <button class="select"> shows the selected value
      var selectBtn = fs.querySelector('button.select > span:first-child');
      if (selectBtn) return selectBtn.textContent.trim();
    }

    return '';
  };

  var updateVariantTextBlock = function (block) {
    var optionName = block.getAttribute('data-option-name');
    var triggerValue = normaliseVariantText(block.getAttribute('data-trigger-value'));
    if (!optionName) return;

    // Scope to the variant-picker inside the same product section
    var section = block.closest('.shopify-section') || document;
    var picker = section.querySelector('variant-picker');
    if (!picker) return;

    var current = normaliseVariantText(getSelectedValueForOption(picker, optionName));
    // 2026-04-24: matching broadened from equality to substring (indexOf)
    // so trigger_value "Limited" catches "Limited", "Limited Edition", etc.
    // Catalog scan confirms no "Unlimited" option values exist (safe).
    var shouldShow = !!current && !!triggerValue && current.indexOf(triggerValue) !== -1;

    if (shouldShow) {
      block.hidden = false;
      block.removeAttribute('hidden');
      block.setAttribute('aria-hidden', 'false');
    } else {
      block.hidden = true;
      block.setAttribute('aria-hidden', 'true');
    }
  };

  var updateAllVariantTextBlocks = function () {
    var blocks = document.querySelectorAll('[data-egoss-variant-text]');
    for (var i = 0; i < blocks.length; i++) updateVariantTextBlock(blocks[i]);
  };

  var variantTextUpdateTimer = null;
  var scheduleVariantTextUpdate = function () {
    if (variantTextUpdateTimer) clearTimeout(variantTextUpdateTimer);
    variantTextUpdateTimer = setTimeout(updateAllVariantTextBlocks, 50);
  };

  var initVariantText = function () {
    if (!document.querySelector('[data-egoss-variant-text]')) return;

    // Native option-input change (works for block / swatch / variant_image picker styles).
    // Capture phase so we run before any handler that might stopPropagation.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('input[data-option-position], select[name^="options"]')) {
        scheduleVariantTextUpdate();
      }
    }, true);

    // Prestige's custom events — variant:change bubbles; product:rerender stays on form.
    document.addEventListener('variant:change', scheduleVariantTextUpdate, true);

    document.querySelectorAll('product-form').forEach(function (form) {
      form.addEventListener('product:rerender', function () {
        // Partial rerender replaces <variant-picker>; give it a tick to settle.
        setTimeout(updateAllVariantTextBlocks, 20);
      });
    });

    // Initial pass (server state is authoritative but belt-and-braces).
    updateAllVariantTextBlocks();
  };

  /* ---------- 4. "You May Also Like" mobile carousel nav (Phase 4a-fix-2) ---------- */

  /* Wires the circular chevron buttons below the related-products carousel
     to scroll one card forward/back. Desktop CSS hides .egoss-pairs-well-with__nav
     via display:none so this runs harmlessly. */

  var initPairsWellWithCarousel = function () {
    var container = document.querySelector('.egoss-pairs-well-with');
    if (!container) return;

    var scrollable = container.querySelector('scroll-carousel, product-list, .product-list');
    if (!scrollable) return;

    var prevBtn = container.querySelector('[data-egoss-pairs-prev]');
    var nextBtn = container.querySelector('[data-egoss-pairs-next]');
    if (!prevBtn || !nextBtn) return;
    if (scrollable.__egossPairsCarouselWired) return;
    scrollable.__egossPairsCarouselWired = true;

    var getCardStep = function () {
      var card = scrollable.querySelector('.product-card, product-card');
      if (!card) return 0;
      var rect = card.getBoundingClientRect();
      var styles = getComputedStyle(scrollable);
      var gapValue = styles.columnGap || styles.gap || '16';
      var gap = parseFloat(gapValue) || 16;
      return rect.width + gap;
    };

    var scrollByOneCard = function (direction) {
      var step = getCardStep();
      if (!step) return;
      scrollable.scrollBy({ left: step * direction, behavior: 'smooth' });
    };

    var updateDisabled = function () {
      var atStart = scrollable.scrollLeft <= 1;
      var atEnd = scrollable.scrollLeft + scrollable.clientWidth >= scrollable.scrollWidth - 1;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    };

    prevBtn.addEventListener('click', function () { scrollByOneCard(-1); });
    nextBtn.addEventListener('click', function () { scrollByOneCard(1); });
    scrollable.addEventListener('scroll', updateDisabled, { passive: true });
    window.addEventListener('resize', updateDisabled);
    updateDisabled();
  };

  /* ---------- boot ---------- */

  var boot = function () {
    initGalleryArrows();
    initWidthCollapsible();
    initVariantText();
    initPairsWellWithCarousel();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
